<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="edit_user_property" width="30px" height="30px" viewBox="0 0 24 24">
    <path :fill="color" d="m21.996,5.826L14.517.778c-1.527-1.033-3.506-1.033-5.033,0L2.004,5.825C.762,6.663.021,8.057.021,9.556v9.925c0,2.481,2.019,4.5,4.5,4.5h14.959c2.481,0,4.5-2.019,4.5-4.5v-9.925c0-1.499-.741-2.893-1.983-3.729ZM7.002,22.98c.011-2.748,2.248-4.98,4.998-4.98s4.987,2.233,4.998,4.98H7.002Zm15.978-3.5c0,1.93-1.57,3.5-3.5,3.5h-1.48c-.011-3.3-2.697-5.98-5.999-5.98s-5.988,2.681-5.999,5.98h-1.48c-1.93,0-3.5-1.57-3.5-3.5v-9.925c0-1.165.576-2.25,1.542-2.901L10.042,1.606c.595-.401,1.276-.602,1.958-.602s1.363.201,1.958.602l7.479,5.049c.966.65,1.542,1.735,1.542,2.9v9.925ZM12,7c-2.206,0-4,1.794-4,4s1.794,4,4,4,4-1.794,4-4-1.794-4-4-4Zm0,7c-1.654,0-3-1.346-3-3s1.346-3,3-3,3,1.346,3,3-1.346,3-3,3Z"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#5a6b8e'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/UserPropertyIcon.vue